export enum WorkOrderStatuses {
  Outstanding = 0,
  Completed = 1,
  Closed = 2,
  Estimate = 3,
  Archived = 4,
  Pending = 5,
  ActiveWorkOrders = 6,
  UnassignedWorkOrders = 7,
}
